<template>
  <div class="q-mx-xs q-mt-xs">
    <DataTable ref="DT"
               :opts="opts"
               @onSelRow="onSelRow"
               @onUpdate="onUpdate">
      <template #buttons>
        <q-btn v-if="sel === true"
               color="primary"
               label="Nueva Nota"
               @click="DNNonoff = true">
        </q-btn>
      </template>
    </DataTable>
    <div class="row">
      <q-chip dense
              square
              :style="{ backgroundColor: '#b6ffbf', color: 'black' }"
              icon="task_alt">Leídos</q-chip>
    </div>
    <NuevaNota :dialog="DNNonoff"
               :data="rec"
               :table="table"
               @dialog="DNNonoff = false">
    </NuevaNota>
  </div>

</template>
<script setup>
import DataTable from "@/lib/DataTable.vue"
import NuevaNota from "@/lib/NuevaNota.vue"
import { ref, inject, onMounted, watch } from "vue"
import { useRoute } from "vue-router"
const global = inject("global")
const route = useRoute();
const sel = ref();
const rec = ref();
const opts = ref({ table: '', url: null })
const DT = ref()
//NUEVANOTA
const DNNonoff = ref(false)
const table = ref("SiniestrosGestion")
// DATATABLE FUNCTIONS
function onUpdate(d) {
  opts.value.defs = { Fecha: global.data.getDate(0), De: global.user.name, Completada: 0, AvisoFin: 0 }
}

function onSelRow(d) {
  sel.value = !!d;
  if (d)
    rec.value = d;
}

async function init() {
  opts.value = {
    details: [{ key: "Siniestro", table: "SiniestrosGestion" }],
    post: {
      table: "Siniestros",
      query: "select",
      where: {
        Mediador: global.user.area
      }
    }
  };
  const { id } = route.params;
  id == "SiniestrosHoy" ? opts.value.post = {
    ...opts.value.post,
    query: "SiniestrosHoy",
    where: {
      ...opts.value.post.where,
      Estado: "Pendiente",
      Responsable: global.user.name,
      Fecha: global.data.getDate(-7),
      Movimiento: 'Aperturas'
    }
  } : "";
  id == "MisPendientes" ? opts.value.post = {
    ...opts.value.post,
    where: {
      ...opts.value.post.where,
      Responsable: global.user.name
    }
  } : "";
  const res = await global.db("/app/db/selSiniestros", opts.value.post);
  DT.value.updateData(res)
}

onMounted(() => { init() })
watch([route, () => global.user.area], () => { init() });
</script>